import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#164E91',
      light: '#2B6CB0',
      dark: '#123E73',
    },
    secondary: {
      main: '#2B6CB0',
      light: '#4A86C4',
      dark: '#20558F',
    },
    error: {
      main: '#d32f2f',
    },
    warning: {
      main: '#ed6c02',
    },
    info: {
      main: '#4EB8C5',
    },
    success: {
      main: '#22C55E',
    },
    background: {
      default: '#F3F7FD',
      paper: '#ffffff',
    },
    text: {
      primary: '#153a67',
      secondary: '#57708f',
    },
  },
  typography: {
    fontFamily: [
      '"Manrope"',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.75rem',
      fontWeight: 800,
      letterSpacing: '-0.03em',
    },
    h2: {
      fontSize: '2.25rem',
      fontWeight: 800,
      letterSpacing: '-0.03em',
    },
    h3: {
      fontSize: '1.9rem',
      fontWeight: 800,
      letterSpacing: '-0.02em',
    },
    h4: {
      fontSize: '1.65rem',
      fontWeight: 800,
      letterSpacing: '-0.02em',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 700,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 700,
    },
    body1: {
      lineHeight: 1.65,
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.95rem',
    },
    caption: {
      fontSize: '0.8rem',
    },
    button: {
      fontWeight: 700,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: 'linear-gradient(180deg, #F7FAFF 0%, #EEF3FB 100%)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 700,
          borderRadius: 12,
        },
        contained: {
          boxShadow: '0 10px 24px rgba(22, 78, 145, 0.25)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          '& .MuiStepLabel-label': {
            fontWeight: 700,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 10px 40px rgba(15, 40, 74, 0.12)',
        },
      },
    },
  },
});
